import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  width: 100%;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
`;

const NavigationContainer = styled.div`
  margin: 16px 32px 0px 32px;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const NavigationWrapper = styled.nav`
  margin: 0px;
  border-bottom: 1px solid black;
  //  align-items: center;
`;

const NavigationList = styled.ul`
  list-style-type: none;
  float: left;
  display: flex;
  flex-wrap: wrap;
  //  width: 100%;
`;

const NavigationItem = styled.li`
  //  border-width: 2px 2px 2px 2px;
  //  border-style: solid;
  //  border-color: white;
  flex: 1;
`;

const NavigationLink = styled(Link)`
  padding: 0.5em 1em;
  // background-color: #c0c0c0;
  &:hover {
    background-color: #f0f0f0;
    transition-duration: 200ms;
  }
  text-align: center;
  text-decoration: none;
  color: black;
  font-variant: small-caps;
  /* font-weight: bold; */
  font-size: 14pt;
  display: block;
`;

const SiteTitleContainer = styled.div`
  width: 100%;
  background-color: white;
`;

const SiteTitle = styled(Link)`
  padding: 20px 20px 10px 20px;
  font-size: 36px;
  text-decoration: none;
  display: block;
  color: darkslategrey;
  text-align: center;
  font-weight: bold;
`;

const SiteSubtitle = styled.div`
  padding: 0px 20px 10px 20px;
  font-size: 16px;
  display: block;
  text-align: center;
  color: darkslategrey;
`;

const Navbar = () => {
  return (
    <Container>
      <SiteTitleContainer>
        <SiteTitle to="/">Blaine Billings</SiteTitle>
        <SiteSubtitle>blaine.t.billings@gmail.com</SiteSubtitle>
        <SiteSubtitle>
          PhD Candidate | Linguistics | University of Hawai'i at Mānoa
        </SiteSubtitle>
      </SiteTitleContainer>
      <Header>
        <NavigationContainer>
          <NavigationWrapper>
            <NavigationList>
              <NavigationItem>
                <NavigationLink to="/">Home</NavigationLink>
              </NavigationItem>
              <NavigationItem>
                <NavigationLink to="/research">Research</NavigationLink>
              </NavigationItem>
              <NavigationItem>
                <NavigationLink to="/publications">Publications</NavigationLink>
              </NavigationItem>
              <NavigationItem>
                <NavigationLink to="/presentations">
                  Presentations
                </NavigationLink>
              </NavigationItem>
              {true && (
                <div>
                  <NavigationItem>
                    <NavigationLink to="/cv">Curriculum Vitae</NavigationLink>
                  </NavigationItem>
                </div>
              )}
              {false && (
                <div>
                  <NavigationItem>
                    <NavigationLink to="/contact">Contact</NavigationLink>
                  </NavigationItem>
                </div>
              )}
            </NavigationList>
          </NavigationWrapper>
        </NavigationContainer>
      </Header>
    </Container>
  );
};

export default Navbar;
